import { catalogueitemConstants } from '../constants';

export function catalogueitems(state = {}, action) {
  switch (action.type) {

    case catalogueitemConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case catalogueitemConstants.GETALL_SUCCESS:
      return {
        items: action.catalogueitems
      };
    case catalogueitemConstants.GETALL_FAILURE:
      return {
        error: action.error
      };

    case catalogueitemConstants.DELETE_REQUEST:
      // add 'deleting:true' property to catalogueitem being deleted
      return {
        ...state,
        items: state.items.map(catalogueitem =>
          catalogueitem.id === action.id
            ? { ...catalogueitem, deleting: true }
            : catalogueitem
        )
      };
    case catalogueitemConstants.DELETE_SUCCESS:
      // remove deleted catalogueitem from state
      return {
        items: state.items.filter(catalogueitem => catalogueitem.id !== action.id)
      };
    case catalogueitemConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to catalogueitem
      return {
        ...state,
        items: state.items.map(catalogueitem => {
          if (catalogueitem.id === action.id) {
            // make copy of catalogueitem without 'deleting:true' property
            const { deleting, ...catalogueitemCopy } = catalogueitem;
            // return copy of catalogueitem with 'deleteError:[error]' property
            return { ...catalogueitemCopy, deleteError: action.error };
          }

          return catalogueitem;
        })
      };

    default:
      return state
  }
}
